import styled, {css} from "styled-components"

export const HeaderLogo = styled.img`
  ${({theme}) => css`
    margin-top: ${theme.spacing.two};
    margin-bottom: ${theme.spacing.two};
    max-width: 300px;
    max-height: 300px;
    ${theme.mediaQueries.maxWidthMedia.tablet`
    max-width: 100px;
    max-height: 100px;
    `}
  `}
`
